<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Events'"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">
					CorDx Events
				</div>
				<div class="txt" style="text-align: center;">
					Transforming Global Diagnostics
				</div>
				<div class="bg_box">
					<img class="bg" src="../../assets/img_h5/Event_YD.webp" />
				</div>
			</div>
			<!--块1-->
			<!--视频-->
			<div class="video_box">
				<iframe src="https://www.youtube.com/embed/Nud5iJyk24A" title="CorDx x ADLM 2025" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
			</div>
			<!--视频-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div v-for="(value, index) in eventsData" :key="index" :class="value.image != '' ? 'block_2_el' : 'block_1_el'">
					<img v-if="value.image != ''" class="img_bg" :src="value.image" />
					<div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);width: 80%;">
						<div class="tit">{{ value.title }}</div>
						<div class="txt">{{ value.shijian }}</div>
						<div class="txt">{{ value.address }}</div>
						<div class="txt">{{ value.zhanhuihao }}</div>
						<div class="btn_box_ty btn_box" @click="goEventsInfo(value)">
							Learn More
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">Contact us</div>
				<div class="block_3_el">
					<div class="left">
						<img src="../../assets/img_h5/icon@2x.png" />
					</div>
					<div class="right">
						5900 Windward Pkwy, Alpharetta, GA 30005
					</div>
				</div>
				<!-- <div class="block_3_el">
					<div class="left">
						<img src="../../assets/img_h5/icon@2x.png" />
					</div>
					<div class="right">
						9540 Waples St. #C, San Diego, CA 92121
					</div>
				</div> -->
				<div class="block_3_el">
					<div class="left">
						<img src="../../assets/img_h5/icon@2x (1).png" />
					</div>
					<div class="right">
						+1 (800) 711-5355
					</div>
				</div>
				<div class="block_3_el">
					<div class="left">
						<img src="../../assets/img_h5/icon@2x (2).png" />
					</div>
					<div class="right">
						<a style="color: #000000 !important;" href="mailto:info@cordx.com">info@cordx.com</a>
					</div>
				</div>
			</div>
			<!--块3-->
			<div class="block_4"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true" :pageName="'About'"
			>
				<contact :titleText="'Subscribe'"></contact>
			</div>
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import contact from '@/component/contact.vue'  //联系我们
import { eventsList } from '@/api/public';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
		contact,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			eventsData: [],  //展会数据
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
	},
	mounted() {
		let that = this;
		//查询展会信息
		eventsList({
			language: sessionStorage.getItem('lang'),
		}).then(res => {
			that.eventsData = res.data;
			that.isLoading = false;
		});
	},
	watch: {
		//
	},
	methods: {
		goEventsInfo(value) {
			let that = this;
			if(value.url) {
				window.location.href = value.url;
			}else {
				that.$router.push({ name: 'Eventsinfo', params: { eventsInfoId: value.custom, } });
			}
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	.video_box{
		position: relative;
		padding: 40px 20px 0 20px;
		iframe{
			width: 100%;
			height: 51.25vw;
		}
	}
	.block_4{
		padding: 0 20px 50px 20px;
	}
	/*块2*/
	.block_3{
		padding: 42px 20px 20px 20px;
		.block_3_el{
			padding-bottom: 20px;
			display: flex;
			align-items: center;
			.left{
				width: 30px;
				img{ width: 100%; }
			}
			.right{
				flex: 1;
				padding-left: 10px;
				font-size: 18px;
			}
		}
		.title{
			padding-bottom: 42px;
			font-size: 42px;
		}
	}
	/*块2*/
	.block_2{
		width: 100%;
		position: relative;
		overflow: hidden;
		margin: 0 auto;
		padding: 21px 20px 21px 20px;
		text-align: left;
		.block_2_el:hover{
			background-color: rgba(0, 0, 0, 0.3);
		}
		.block_2_el{
			display: inline-block;
			width: 100%;
			height: 300px;
			margin: 8px 0;
			// margin: 0 1.5% 30px 1.5%;
			// padding: 50px 40px 40px 40px;
			text-align: center;
			position: relative;
			background-color: rgba(0, 0, 0, 0.4);
			img.img_bg{
				position: absolute;
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				z-index: -1;
				object-fit: cover;
			}
			.btn_box{
				margin-top: 21px;
				color: #ffffff;
				border: 1px solid #ffffff;
				text-shadow: 2px 2px 2px #666666;
			}
			.btn_box:hover{
				img{
					transform: translateX(6px);
				}
				background-color: transparent;
			}
			.txt{
				padding: 2px 0;
				font-size: 18px;
				color: #ffffff;
				text-shadow: 2px 2px 2px #666666;
			}
			.tit{
				padding-bottom: 10px;
				font-size: 30px;
				color: #ffffff;
				text-shadow: 2px 2px 2px #666666;
			}
		}
		.block_1_el{
			position: relative;
			display: inline-block;
			width: 100%;
			margin: 8px 0;
			height: 300;
			// margin: 0 1.5% 30px 1.5%;
			//padding: 50px 40px 40px 40px;
			// margin: 0 1.5% 30px 1.5%;
			// padding: 50px 40px 40px 40px;
			background-color: #F2F7FD;
			text-align: center;
			.btn_box{
				margin-top: 21px;
			}
			.txt{
				font-size: 18px;
				color: #000000;
			}
			.tit{
				padding-bottom: 10px;
				font-size: 30px;
				color: #0B318F;
			}
		}
	}
	/*块1*/
	.block_1{
		padding: 22px 0 0 0;
		color: #3D3D3D;
		.bg_box{
			img{ width: 100%; }
		}
		.txt{
			padding: 0 20px 30px 20px;
			font-size: 20px;
		}
		.tit{
			text-align: center;
			padding: 0 20px;
			font-size: 42px;
		}
	}
}
</style>
